import React, {Component} from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Dialog } from 'primereact/dialog';

import Iframe from '@components/Iframe';

import { generateLayoutsHtml } from '@actions/sections';

class ModalPreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingPage: true,
      layoutHtml: '',
    }
  }

  async componentDidMount () {
    const { generateLayoutsHtml, language, componentsSelected, componentsAvailables } = this.props
    let response = await generateLayoutsHtml({
      componentsSelected,
      componentsAvailables
    })
    let findHtml = response.find(item => item.language === language)
    const previewHtml = findHtml.previewHtml || findHtml.html
    this.setState({layoutHtml: previewHtml})
    this.setState({ loadingPage: false })
    setTimeout(() => {
      this.setState({layoutHtml: previewHtml})
    }, 1000)
  }
  
  render () {
    const { t, title, onHide } = this.props
    const { loadingPage, layoutHtml } = this.state
    // if (loadingPage) return true
    return (
      <Dialog header={title || t('Previsualizar')} visible={true} style={{ width: '70vw' }} breakpoints={{'960px': '90vw'}} maximizable modal  onHide={() => onHide()}>
        {
          !loadingPage && (
            <div className="p-shadow-3 content-iframe">
              <Iframe content={layoutHtml.outerHTML} />
            </div>
            )
        }
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
  layoutsHtml: state.section.layoutsHtml,
  componentsAvailables: state.section.componentsAvailables,
  componentsSelected: state.section.componentsSelected
});

const mapDispatchToProps = {
  generateLayoutsHtml
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ModalPreview);
